import Cookies from 'js-cookie'

// token role id menus powers name

const TokenKey = 'daishu_token'
const RoleKey = 'daishu_role'
const NameKey = 'daishu_name'
const IdKey = 'daishu_id'
const MenuKey = 'daishu_menu'
const PowerKey = 'daishu_power'

export function getPower() {
  let power = JSON.parse(Cookies.get(PowerKey))
  return power.power
}

export function setPower(power) {
  let jsstr = {'power': power}
  return Cookies.set(PowerKey, JSON.stringify(jsstr))
}

export function removePower() {
  return Cookies.remove(PowerKey)
}

export function getMenu() {
  let menu = JSON.parse(Cookies.get(MenuKey))
  return menu.menu
}

export function setMenu(menu) {
  let jsstr = {'menu': menu}
  return Cookies.set(MenuKey, JSON.stringify(jsstr))
}

export function removeMenu() {
  return Cookies.remove(MenuKey)
}

export function getId() {
  return Cookies.get(IdKey)
}

export function setId(id) {
  return Cookies.set(IdKey, id)
}

export function removeId() {
  return Cookies.remove(IdKey)
}

export function getName() {
  return Cookies.get(NameKey)
}

export function setName(name) {
  return Cookies.set(NameKey, name)
}

export function removeName() {
  return Cookies.remove(NameKey)
}


export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}


export function getRole() {
  return Cookies.get(RoleKey)
}

export function setRole(role) {
  return Cookies.set(RoleKey, role)
}

export function removeRole() {
  return Cookies.remove(RoleKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js